import { RouteLocationNormalized } from 'vue-router';
import { toast } from '~/composables/useToast';
import { useSettingsStore, useUserStore } from '~/stores';

class Require2FA implements Middleware {
    static LEVEL_NONE = 0;
    static LEVEL_ADMIN = 1;
    static LEVEL_ALL = 2;

    private except = ['account.settings.2fa'];

    name() {
        return 'require_2fa';
    }

    async run(to: RouteLocationNormalized) {
        const userStore = useUserStore();
        const settingsStore = useSettingsStore();

        if (!userStore.data) return;

        const required = settingsStore.data?.misc?.required_2fa || 0;
        if (required > 0 && !userStore.data?.has2fa) {
            if (required === Require2FA.LEVEL_ADMIN) {
                const user = userStore.data;
                if (!user?.rootAdmin && !user?.supportOp) return;
            }

            if (this.except.includes((to.name || '').toString())) return;

            toast.error(['client.account.2fa_must_be_enabled']);

            return {
                name: 'account.settings.2fa',
            };
        }
    }
}

export default new Require2FA();
